/**
 * G8. Очередь: пять окошек, у каждого ожидание, цена (по `oopHealth`) и
 * здоровье; бесплатное окно в бедной стране может быть закрыто — шанс
 * написан. Окно дороже сбережений выключено. Один тап — исход.
 */
import { t } from '@life/i18n';
import type { ClinicInput, ClinicState } from '@life/minigames';
import { money } from '../lib/format';
import type { MinigameScreenProps } from './types';
import { Choice } from './ui/Choice';

export function Clinic({ state, onInput }: MinigameScreenProps<ClinicInput, ClinicState>) {
  return (
    <>
      <p class="hint">{t('ui.minigame.clinic.rules', { money: money(state.money) })}</p>
      <Choice
        label={t('ui.minigame.clinic.label')}
        items={state.windows.map((w) => {
          const noMoney = w.cost > state.money;
          const parts = [
            w.id === 'none' ? t('ui.minigame.clinic.none', { h: w.health }) : t('ui.minigame.clinic.window', { days: w.waitDays, sum: money(w.cost), h: w.health }),
            w.closedP > 0 ? t('ui.minigame.clinic.closedP', { p: Math.round(w.closedP * 100) }) : '',
            noMoney ? t('ui.minigame.clinic.noMoney') : '',
          ].filter(Boolean);
          return { text: t(w.key), note: parts.join(' · '), disabled: noMoney };
        })}
        value={null}
        onChange={(pick) => onInput({ pick })}
      />
    </>
  );
}
